<template>
  <div class="starzaym">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <div class="showcase-wrapper" :class="{ 'showcase-wrapper--no-swiper': !isSwiperEnabled }">
          <div v-if="isSwiperEnabled" class="swiper-pagination" ref="pagination"></div>
      <div v-if="isSwiperEnabled" class="swiper-text__label">Листайте влево</div>
      <div class="swiper showcase-swiper" ref="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
            <div class="card">
              <img src="img/scale.svg" alt="" class="scale" />
              <div class="card-wrapper">
                <div class="card-logo">
                  <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
                </div>
                <div class="card-info">
                  <div class="card-info__rate">
                    <star-rating :max="5" :current="offer.rating"></star-rating>
                  </div>
                  <div class="card-info__wrapper">
                    <div class="card-info__wrapper__logo">
                      <img src="/img/rub.svg" alt="" />
                    </div>
                    <div class="card-info__wrapper__value">
                      до {{ numberFormat(offer.amount) }} ₽
                    </div>
                  </div>
                  <div class="card-info__wrapper">
                    <div class="card-info__wrapper__logo">
                      <img src="/img/date.svg" alt="" />
                    </div>
                    <div class="card-info__wrapper__value">
                      до {{ offer.period }} дней
                    </div>
                  </div>
                  <div class="card-info__wrapper">
                    <div class="card-info__wrapper__logo">
                      <img src="/img/perc.svg" alt="" />
                    </div>
                    <div class="card-info__wrapper__value">
                      Без % - <div v-if="offer.without_percent" class="card-info__value">да</div>
                      <div v-if="!offer.without_percent" class="card-info__value">нет</div>
                    </div>
                  </div>
                  <div class="card-btn" @click="openLinks(offer)">
                    <button type="button">
                      ПОЛУЧИТЬ ЗАЕМ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- СТРЕЛКИ — ТОЛЬКО МОБИЛКА -->
              <button v-if="isSwiperEnabled" class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }">‹</button>
              <button v-if="isSwiperEnabled" class="showcase-nav next" ref="nextBtn">›</button>

      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import StarRating from "@/components/StarRating";

import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "ShowcaseStarzaym",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { StarRating, CheckerOffersBlock },

  props: {
    offers: Array,
    checkerOffers: Array,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },
  },

  methods: {

    numberFormat(n) { return Functions.numberFormat(n); },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      (offer.links || []).forEach((l) => window.open(l, "_blank"));
    }
  }
};
</script>
<style lang="css">
@import url(../assets/css/starzaym.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.starzaym .card-info__wrapper {
  border-radius: 23.226px;
  background: #f3f3f3;
  display: flex;
  align-items: center;
  padding: 5px;

}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}

  .swiper-text__label{
  display: none;
}
@media (max-width: 768px) {
  .swiper-text__label{
  display: block;
  font-weight: 400;
  font-size: 16px;
}
  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

/* ===========================
   ДЕСКТОП (старый вид, без свайпера)
   =========================== */

@media (min-width: 768px) {

  /* полосы и стрелки вообще не показываем */
  .showcase-wrapper>.swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  .starzaym .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .starzaym .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
  }

  .starzaym .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 355px;
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .starzaym .showcase-wrapper--no-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }

  /* обычная сетка карточек */
  .starzaym .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
    /* или center, если хочешь по центру */
  }

  .starzaym .showcase-swiper .swiper-slide {
    flex: 0 0 355px;
    /* ЖЁСТКАЯ ширина колонки */
    max-width: 355px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .starzaym .showcase-swiper .card {
    width: 100%;
    max-width: 355px;
    box-sizing: border-box;
  }
}

/* ===========================
   МОБИЛКА (Swiper + прогресс + стрелки)
   =========================== */
@media (max-width: 767px) {

  .showcase-wrapper {
    padding: 0 0 20px;
  }

  .starzaym .showcase-wrapper--no-swiper {
    padding: 0;
  }

  .starzaym .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .starzaym .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: center;
    transform: none !important;
  }

  .starzaym .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 310px;
    max-width: 310px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .starzaym .showcase-wrapper--no-swiper .card {
    max-width: 310px;
    width: 100%;
  }

  /* ПРОГРЕССБАР СВЕРХУ */
  .starzaym .showcase-wrapper>.swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    /* как карточка */
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    /* ЦЕНТРИРУЕМ */
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .starzaym .showcase-wrapper>.swiper-pagination .swiper-pagination-progressbar-fill {
    background: #ed885c;
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    /* чтобы стрелки не обрезались */
    position: relative;
  }

  .starzaym .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  /* СТРЕЛКИ */
  .starzaym .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: #ed885c;
    border-radius: 50%;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .starzaym .showcase-wrapper {
    flex-direction: row;
  }

  .starzaym .showcase-wrapper--no-swiper .card {
    max-width: 310px !important;
    width: 100% !important;
  }
}
</style>

